module.exports = __webpack_public_path__ + "img/fj.9ccd0de2.svg";